import { render, staticRenderFns } from "./recommandations3.vue?vue&type=template&id=68066f2b&scoped=true&"
import script from "./recommandations3.vue?vue&type=script&lang=js&"
export * from "./recommandations3.vue?vue&type=script&lang=js&"
import style0 from "./recommandations3.vue?vue&type=style&index=0&id=68066f2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68066f2b",
  null
  
)

export default component.exports